import React, {Component} from 'react';
import ReactModal from 'react-modal';
import '../assets/custom.css';
import '../assets/teachers.css';
import '../assets/apps.css';

import ReactPlayer from 'react-player';
import {Animated} from "react-animated-css";
import animal1 from '../assets/images/levels/level0.png';
import animal2 from '../assets/images/levels/level1.png';
import animal3 from '../assets/images/levels/level2.png';
import animal4 from '../assets/images/levels/level3.png';
import animal5 from '../assets/images/levels/level4.png';
import animal6 from '../assets/images/levels/level5.png';
import animal7 from '../assets/images/levels/level6.png';
import animal8 from '../assets/images/levels/level7.png';
import animal9 from '../assets/images/levels/level8.png';
import animal10 from '../assets/images/levels/level9.png';
import animal11 from '../assets/images/levels/level10.png';
import animal12 from '../assets/images/levels/level11.png';
import medalanimal1 from '../assets/images/levels/medal_level0.png';
import medalanimal2 from '../assets/images/levels/medal_level1.png';
import medalanimal3 from '../assets/images/levels/medal_level2.png';
import medalanimal4 from '../assets/images/levels/medal_level3.png';
import medalanimal5 from '../assets/images/levels/medal_level4.png';
import medalanimal6 from '../assets/images/levels/medal_level5.png';
import medalanimal7 from '../assets/images/levels/medal_level6.png';
import medalanimal8 from '../assets/images/levels/medal_level7.png';
import medalanimal9 from '../assets/images/levels/medal_level8.png';
import medalanimal10 from '../assets/images/levels/medal_level9.png';
import medalanimal11 from '../assets/images/levels/medal_level10.png';
import medalanimal12 from '../assets/images/levels/medal_level11.png';
import active from '../assets/images/activeStepBar.png';
import inactive from '../assets/images/inactiveStepBar.png';
import badge1 from '../assets/images/badge_1.png';
import badge2 from '../assets/images/badge_2.png';
import badge3 from '../assets/images/badge_3.png';
import badge4 from '../assets/images/badge_4.png';
import badge5 from '../assets/images/badge_5.png';
import badge6 from '../assets/images/badge_6.png';
import badge7 from '../assets/images/badge_7.png';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {updateAppStates, updateStudentAccountTab, updateStudentAppsStatus} from "./actions";
import DialogBox from "../Shared/DialogBox";
import icon_datachart from "../assets/images/data-chart.png";
import REST from "../Shared/REST";
import {updateStudent} from "../TeachersComponent/actions";

import Lottie from "lottie-react";
import excellentAnimation from "../assets/images/words/excellent.json";
import fantasticAnimation from "../assets/images/words/fantastic.json";
import goodWorkAnimation from "../assets/images/words/good-work.json";
import greatJobAnimation from "../assets/images/words/great-job.json";
import greatAnimation from "../assets/images/words/great.json";
import hoorayAnimation from "../assets/images/words/hooray.json";
import wellDoneAnimation from "../assets/images/words/well-done.json";
import wowAnimation from "../assets/images/words/wow.json";
import youDidItAnimation from "../assets/images/words/you-did-it.json";
import Helpers from "../Shared/Helpers";




const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '45%'
    }
};

export class LevelAnimation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            randomTitleNo:  Math.floor(Math.random()* 9), // 9 animation words
        };
    }

    level(level) {
        switch (level) {
            case 1:
                return animal1;
            case 2:
                return animal2;
            case 3:
                return animal3;
            case 4:
                return animal4;
            case 5:
                return animal5;
            case 6:
                return animal6;
            case 7:
                return animal7;
            case 8:
                return animal8;
            case 9:
                return animal9;
            case 10:
                return animal10;
            case 11:
                return animal11;
            case 12:
                return animal12;
        }
    }

    render() {
        const level = <img style={{position:'absolute', margin:'auto',top:0,bottom:0,left:0,right:0, maxWidth:70}} src={this.props.level <= this.props.maxLevel ? this.level(this.props.level) : this.props.appName === "slash" ? badge3 : badge5} alt="animal"/>;
        let wordAnimation = null;
        switch(this.state.randomTitleNo){
            case 0:
                wordAnimation = excellentAnimation;
                break;
            case 1:
                wordAnimation = fantasticAnimation;
                break;
            case 2:
                wordAnimation = goodWorkAnimation;
                break;
            case 3:
                wordAnimation = greatJobAnimation;
                break;
            case 4:
                wordAnimation = greatAnimation;
                break;
            case 5:
                wordAnimation = hoorayAnimation;
                break;
            case 6:
                wordAnimation = wellDoneAnimation;
                break;
            case 7:
                wordAnimation = wowAnimation;
                break;
            case 8:
                wordAnimation = youDidItAnimation;
                break;
        }
        return (
            <Animated animationIn="fadeIn" isVisible={true}>
                <div style={{position:'fixed',top:0, left:0,width:'100%',height:'100%',background:'#fff'}}>
                    <div className={"centeredMiddle"}>
                        <Animated animationIn="zoomIn" isVisible={true} style={{display:"inline-block"}}>
                            <Lottie style={{width:'50%', height:'50%', marginLeft:'auto', marginRight:'auto', marginBottom: 20}} animationData={wordAnimation} />
                            <div className="center-block" style={{width:'100%', height:48, position:'relative'}}>{level}</div>
                            <div style={{fontFamily:'Neucha',fontSize:40}}>{this.props.typeLevel}</div>
                            <div style={{marginTop:80}}>
                                <a onClick={this.props.closeAnimation} className="handBtn">
                                    <span>Continue</span>
                                </a>
                            </div>
                        </Animated>
                    </div>
                </div>
            </Animated>
        );
    }
}

export class LevelTrackerComponent extends Component {
    level(level) {
        switch (level) {
            case 1:
                return animal1;
            case 2:
                return animal2;
            case 3:
                return animal3;
            case 4:
                return animal4;
            case 5:
                return animal5;
            case 6:
                return animal6;
            case 7:
                return animal7;
            case 8:
                return animal8;
            case 9:
                return animal9;
            case 10:
                return animal10;
            case 11:
                return animal11;
            case 12:
                return animal12;
        }
    }
    appName(appName) {
        switch (appName) {
            case "maze":
                return badge5;
            case "slash":
                return badge3;
            case "copyright":
                return badge1;
            case "picturenaming":
                return badge7;
            case "wordsignsay":
                return badge4;
            case "kidsign":
                return badge6;
            case "kidspeak":
                return badge2;
        }
    }

    render() {
        let level = <img src={this.level(this.props.level)} alt="animal" style={{width:48}}/>;
        let levelPlus = <img src={this.level(this.props.level + 1)} alt="another animal" style={{width:48}}/>
        let steps = [];
        let stepCount = this.props.steps || 6;
        if(this.props.stepDir === "UP" || this.props.stepDir === null){
            for (let i = 1; i <= stepCount; i++) {
                if (i <= this.props.step-1) {
                    if(i !== this.props.step-1) {
                        steps.push(<span key={i}><div className={"square squareOn " + "greenBox"+i}></div></span>);
                    } else {
                        steps.push(
                            <span key={i}>
                            <div className={"square squareOn animate-flicker " + "greenBox"+i}></div>
                        </span>
                        );
                    }
                }
                else {
                    steps.push(<span key={i}><div className={"square "  + "greenBox"+i}></div></span>);
                }
            }
        }
        else if(this.props.stepDir === 'DOWN'){
            steps=[];
            for (let i = 1; i <= stepCount; i++) {
                if (i <= this.props.step-1) {
                        steps.push(<span key={i}><div className={"square squareOn " + "greenBox"+i}></div></span>);
                }
                else if(i === this.props.step){
                    steps.push(<span key={i}><div className={"square animate-flickerDown " + "greenBox"+i}></div></span>);
                }
                else{
                    steps.push(<span key={i}><div className={"square " + "greenBox"+i}></div></span>);
                }
            }
        }
        if(this.props.firstScore){
            steps=[];
            for (let i = 0; i <= stepCount; i++) {
                    steps.push(<span key={i}><div className={"square " + "greenBox"+i}></div></span>);
            }
        }
        if(this.props.lastScore){
            steps=[];
            for (let i = 1; i <= stepCount; i++) {
                if (i <= 6) {
                    if(i !== 6) {
                        steps.push(<span key={i}><div className={"square squareOn " + "greenBox"+i}></div></span>);
                    } else {
                        steps.push(
                            <span key={i}>
                            <div className={"square squareOn animate-flicker " + "greenBox"+i}></div>
                        </span>
                        );
                    }
                }
                else {
                    steps.push(<span key={i}><div className={"square "  + "greenBox"+i}></div></span>);
                }
            }
        }
        if(this.props.level === this.props.maxLevel){
            levelPlus=<img src={this.appName(this.props.appName)} alt="animal" style={{width:48}}/>;
        }
        if(this.props.level === this.props.maxLevel + 1){
            steps=[];
            level = <img src={this.props.appName === "slash" ? badge3 : badge5} alt="animal" style={{width:48}}/>;
            levelPlus='';
        }
        return (
            <div style={{float:'left'}}>{level}{steps}{levelPlus}</div>
        );
    }
}

export class LevelTrackerMainComponent extends Component {
    level(level) {
        switch (level) {
            case 1:
                return animal1;
            case 2:
                return animal2;
            case 3:
                return animal3;
            case 4:
                return animal4;
            case 5:
                return animal5;
            case 6:
                return animal6;
            case 7:
                return animal7;
            case 8:
                return animal8;
            case 9:
                return animal9;
            case 10:
                return animal10;
            case 11:
                return animal11;
            case 12:
                return animal12;
        }
    }
    appName(appName) {
        switch (appName) {
            case "maze":
                return badge5;
            case "slash":
                return badge3;
            case "copyright":
                return badge1;
            case "picturenaming":
                return badge7;
            case "wordsignsay":
                return badge4;
            case "kidsign":
                return badge6;
            case "kidspeak":
                return badge2;
        }
    }

    render() {
        let level = <img src={this.level(this.props.level)} alt="Level" style={{height:60}}/>;
        let levelPlus = <img src={this.level(this.props.level + 1)} alt="Level" style={{height:60}}/>
        let steps = [];
        let stepCount = this.props.steps || 6;
        if (this.props.level > this.props.maxlevel){
           level = '';
           levelPlus = '';
           steps=null;
        }
        else {
            for (let i = 1; i <= stepCount; i++) {
                if (i <= this.props.step-1) {
                    steps.push(<span key={i}><div className="square squareOn"></div></span>);
                }
                else {
                    steps.push(<span key={i}><div className="square"></div></span>);
                }
            }
        }
        if(this.props.level === this.props.maxlevel && this.props.level !== 1){
            levelPlus = <img src={this.appName(this.props.appName)} alt="Level" style={{height:60}}/>;
        }
        if(this.props.level === this.props.maxlevel + 1 && this.props.level !== 1){
            steps = [];
            level = <div style={{position:'relative'}}><div style={{position:'relative',display:"inline-block"}}><img src={this.appName(this.props.appName)} alt="Medal" style={{display:"inline-block",position:'relative',height:60}} /></div><div style={{position:'relative',display:"inline-block"}}><h3 style={{position:'relative',display:"inline-block"}}>ALL LEVELS FINISHED</h3></div><div style={{position:'relative',display:"inline-block"}}><img src={this.appName(this.props.appName)} alt="Medal" style={{position:'relative',display:"inline-block",height:60}} /></div></div>;
            levelPlus = '';
        }
        if(this.props.level === this.props.maxlevel && this.props.appName === "wordsignsay"){
            levelPlus = <img src={this.appName(this.props.appName)} alt="Level" style={{height:60}}/>;
        }
        return (
            <div>{level}{steps}{levelPlus}</div>
        );
    }
}

export class VideoComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            play:false
        }
        this.handlePlay = this.handlePlay.bind(this);
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if ((this.props.url !== prevProps.url)&&(this.props.appName ==='intro')&&(prevProps.appName ==='intro')) {
            this.setState({play:false});
        }
    }

    handlePlay(){
        if(this.state.play){
            this.video.pause();
            this.setState({play:false});
        }
        else{
            this.video.play();
            this.setState({play:true});
        }
    }

    render() {
        return (
            <div className="section">
                <div className="wrapper">
                <video
                       id={"demoVidPlay"}
                       ref={video => {
                           this.video = video
                       }}
                       playsInline={true}
                       src={this.props.url}
                       style={{position: 'relative'}}
                       width="100%"
                       autoPlay={false}
                       controls={true}
                       muted={this.props.appName === "kidspeak"||this.props.appName === "intro" ? false : true}
                       onClick={this.handlePlay}
                />
                <div className={!this.state.play ? "playpause" : ""} style={{cursor:'pointer'}} onClick={this.handlePlay}></div>
                </div>
            </div>
        )
    }
}

export class YouTubeVideoComponent extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
    }

    render() {
        return (
            <div className="section">
                <div className="wrapper">
                    <iframe width={this.props.width?this.props.width:510} height={this.props.height?this.props.height:292} src={this.props.url} frameBorder="0"
                            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen></iframe>
                </div>
            </div>
        )
    }
}

export class CountDownComponent extends Component {

    calculate() {
        let time = this.props.time, sessionTime = this.props.sessionTime;
        let showTime = this.props.showTime;
        let report = time / sessionTime;

        if (report === 1) {
            return 24;
        } else if (report < 1 && report >= 11 / 12) {
            return 1;
        } else if (report < 11 / 12 && report >= 10 / 12) {
            return 2;
        } else if (report < 10 / 12 && report >= 9 / 12) {
            return 3;
        } else if (report < 9 / 12 && report >= 8 / 12) {
            return 4;
        } else if (report < 8 / 12 && report >= 7 / 12) {
            return 5;
        } else if (report < 7 / 12 && report >= 6 / 12) {
            return 6;
        } else if (report < 6 / 12 && report >= 5 / 12) {
            return 7;
        } else if (report < 5 / 12 && report >= 4 / 12) {
            return 8;
        } else if (report < 4 / 12 && report >= 3 / 12) {
            return 9;
        } else if (report < 3 / 12 && report >= 2 / 12) {
            return 10;
        } else if (report < 2 / 12 && report >= 1 / 12) {
            return 11;
        } else if (report <= 1 / 12 && report > 0) {
            return 12;
        } else {
            return 0;
        }
    }

    render() {
        let calc = this.calculate();

        return (
            <div style={(this.props.time > this.props.showTime)?{display:'none'}:{display:'inline-block'}}>
                {calc === 0 ? <div className="timer24 timerBoxSize"></div> : null}
                {calc === 24 ? <div className="timer0 timerBoxSize"></div> : null}
                {calc === 1 ? <div className="timer2 timerBoxSize"></div> : null}
                {calc === 2 ? <div className="timer4 timerBoxSize"></div> : null}
                {calc === 3 ? <div className="timer6 timerBoxSize"></div> : null}
                {calc === 4 ? <div className="timer8 timerBoxSize"></div> : null}
                {calc === 5 ? <div className="timer10 timerBoxSize"></div> : null}
                {calc === 6 ? <div className="timer12 timerBoxSize"></div> : null}
                {calc === 7 ? <div className="timer14 timerBoxSize"></div> : null}
                {calc === 8 ? <div className="timer16 timerBoxSize"></div> : null}
                {calc === 9 ? <div className="timer18 timerBoxSize"></div> : null}
                {calc === 10 ? <div className="timer20 timerBoxSize"></div> : null}
                {calc === 11 ? <div className="timer22 timerBoxSize"></div> : null}
                {calc === 12 ? <div className="timer23 timerBoxSize"></div> : null}
            </div>
        );
    }
}

class ButtonContainerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: 1,
            noDataModel:false,
            currentActive: this.props.currentTabActive
        };
        this.handleBackToMenu = this.handleBackToMenu.bind(this);
        this.handlePlayVideo = this.handlePlayVideo.bind(this);
        this.handleDataChart = this.handleDataChart.bind(this);
        this.handlePractice = this.handlePractice.bind(this);
        this.handleStartTask = this.handleStartTask.bind(this);
        this.handleShowScores = this.handleShowScores.bind(this);
        this.handleBackToPage = this.handleBackToPage.bind(this);
        this.handlePNManual = this.handlePNManual.bind(this);
        this.handlePNStart = this.handlePNStart.bind(this);
        this.handleNoDataClose = this.handleNoDataClose.bind(this);
        this.convertAppName = this.convertAppName.bind(this);
        this.getAppPath = this.getAppPath.bind(this);
    }

    async componentDidMount() {
        await REST.getUngradedTasks(this.props.appName).then(async(res)=>{
            console.log(res);
            if(res.body>=3){
                this.props.history.push('/student');
            }
        });
    }

    handleBackToMenu(event) {
        this.props.history.goBack();
    }

    handlePlayVideo(event) {
        this.props.buttonClick(1);
        this.setState({mode: 1, currentActive: 1});
    }

    handleShowScores(event) {
        this.props.buttonClick(0);
        this.setState({mode: 1, currentActive: 0});
    }

    convertAppName(lowercaseName, model) {
        let capitalName;
        switch (lowercaseName){
            case 'maze':
                capitalName = 'Maze';
                break;
            case 'slash':
                capitalName = 'Slash';
                break;
            case 'wordmark':
                capitalName = 'WordMark';
                break;
            case 'kidspeak':
                capitalName = 'KidSpeak';
                break;
            case 'picturenaming':
                if (!model) {
                    capitalName = 'PictureNaming/Computer';
                }
                break;
            case 'wordsignsay':
                capitalName = 'WordSign/Say';
                break;
            case 'copyright':
                capitalName = 'CopyRight';
                break;
            case 'kidsign':
                capitalName = 'KidSign';
                break;
        }
        return capitalName;

    }

    getAppPath(appName){
        if (appName === 'slash'){
            return 'slashtest';
        }else if(appName === 'picturenaming'){
            return 'picturenaming/computer';
        }else{
            return appName;
        }

    }

    async handleDataChart(event){
        await REST.authWithToken().then(async (res) => {
            let student;
            if (this.props.userRole === "parent") {
                student = this.props.currentStudent;
            } else {
                student = res.body;
                student.userId = res.body.id;
                student.user = {...res.body};
                student.personalUse = true;
            }
            if (student) {
                await this.props.updateStudent(student);
            }
        });
        await REST.checkStudentData(this.props.studentUser.student.userId, this.convertAppName(this.props.appName,this.props.model)).then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/'+ this.getAppPath(this.props.appName));
            }
        });
    }

    async handleNoDataClose(event){
        this.setState({
            noDataModel:false
        });
    }

    handlePractice(event) {
        this.props.buttonClick(2);
        this.setState({mode: 2});
    }

    handleStartTask(event) {
        this.props.buttonClick(3);
        this.setState({mode: 3});
    }

    handlePNManual(event) {
        this.props.buttonClick(4);
        this.setState({mode: 4});
    }

    handlePNStart(event) {
        this.props.buttonClick(3);
        this.setState({mode: 3});
    }

    handleBackToPage(event){
        this.handleShowScores(event);
    }

    render() {

        let appFinished = this.props.appStates.finishedApps.includes(this.props.appName);

        return (
            <div className="section">
                <div className="container">
                    <div className="row">
                        {this.state.mode === 1 ?
                            <div className="divBottomRelative">
                                <div>
                                <div className="tc">
                                    <div className={"col-md-4 col-sm-4"}>
                                    {  this.state.currentActive < 1 ?
                                        <a onClick={this.handleBackToMenu} className="backArrow fl">
                                            <span>Back to Home Page</span>
                                        </a>
                                        :
                                        null
                                    }
                                    </div>
                                    <div className={"col-md-4 col-sm-4"}>
                                        {this.state.currentActive !== 3 && this.state.currentActive<2 && !this.props.pnManual && !appFinished?
                                            <div hidden={this.state.currentActive === 1 || (this.props.maxLevel && this.props.level === this.props.maxLevel + 1)}>
                                                <a onClick={this.handleStartTask} className="handBtn">
                                                    <span>Start</span>
                                                </a>
                                                <a onClick={this.handleDataChart} >
                                                    <img src={icon_datachart} style={{width:25,position:'relative',marginTop:-15,marginLeft:-15}}/>
                                                </a>
                                                <ReactModal isOpen={this.state.noDataModel} style={customStyle}>
                                                    <div className="modal-content content">
                                                        <div className="modal-header">
                                                            <div className="clearfix"></div>
                                                            <h2>No tasks completed yet.</h2>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <a onClick={this.handleNoDataClose} className="handBtn"><span>Close</span></a>
                                                        </div>
                                                    </div>
                                                </ReactModal>
                                            </div>
                                            : null
                                        }
                                        {(this.state.currentActive === 1 || this.state.currentActive !== 3) && this.state.currentActive<2 && this.props.pnManual && !appFinished?
                                            <div>
                                                <a onClick={this.handlePNStart} className="handBtn">
                                                    <span>Start</span>
                                                </a>
                                                <a onClick={this.handleDataChart} >
                                                    <img src={icon_datachart} alt="Student Data" style={{width:25,position:'relative',marginTop:-15,marginLeft:-15}}/>
                                                </a>
                                                <ReactModal isOpen={this.state.noDataModel} style={customStyle}>
                                                    <div className="modal-content content">
                                                        <div className="modal-header">
                                                            <div className="clearfix"></div>
                                                            <h2>No tasks completed yet.</h2>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <a onClick={this.handleNoDataClose} className="handBtn"><span>Close</span></a>
                                                        </div>
                                                    </div>
                                                </ReactModal>
                                            </div>
                                            : null
                                        }
                                    </div>
                                    <div className={"col-md-4 col-sm-4"}>
                                    <div className={"pull-right"} style={{marginRight:15}}>
                                    {this.state.currentActive < 1 ?
                                        this.props.appName === "maze" || this.props.appName ==="slash" || this.props.appName==="wordmark" || this.props.appName ==="picturenaming" || this.props.appName === "wordsignsay" || this.props.appName === "copyright" || this.props.appName === "kidspeak" || this.props.appName === "kidsign" ?
                                        <a onClick={this.handlePlayVideo} className="handBtn">
                                            <span>Show Me</span>
                                        </a>
                                            : null
                                         : null
                                    }
                                    {!this.props.demo && this.state.currentActive<2?
                                        <a onClick={this.handlePractice} className="handBtn">
                                            <span>Practice</span>
                                        </a> : null
                                    }
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class ButtonContainerComponent1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: 1,
            currentActive: this.props.currentTabActive,
            modalDialog: false,
            responseContent:'Data for this task will not be saved if you go back now.'
        };
        this.handleBackToMenu = this.handleBackToMenu.bind(this);
        this.handleShowScores = this.handleShowScores.bind(this);
        this.handleBackToPage = this.handleBackToPage.bind(this);
        this.handleBackToPageConditional = this.handleBackToPageConditional.bind(this);
        this.onUnload = this.onUnload.bind(this);
    }

    onUnload(event) { // the method that will be used for both add and remove event
        event.returnValue = "By leaving or reloading the page you will lose your app progress"
    }
    handleBackToMenu(event) {
        this.props.history.goBack();
    }
    handleShowScores(event) {
        this.props.buttonClick(0);
        window.location.reload();
        this.setState({mode: 1, currentActive: 0});
    }
    handleBackToPage(event){
        this.handleShowScores(event);
    }

    handleBackToPageConditional = (active) => {
        window.removeEventListener("beforeunload", this.onUnload);
        this.setState({modalDialog:true});
        if(active === true){
            this.handleBackToPage();
        }
    }

    render() {
        let appFinished = this.props.appStates.finishedApps.includes(this.props.appName);
        return (
            <div style={{paddingTop:20}}>
                <div className="container">
                    <div className="row">
                        {this.state.mode === 1 ?
                            <div className="divBottomRelative">
                                <div>
                                    <div className="tc">
                                        { this.state.currentActive < 2 ?
                                                !this.props.demo ?
                                                <a onClick={this.handleBackToMenu} className="backArrow fl">
                                                    <span>Back to Home Page</span>
                                                </a>
                                                :
                                                <a onClick={this.handleShowScores} className="backArrow bck fl">
                                                    <span><b>Back</b></span>
                                                </a>
                                            :

                                                this.state.currentActive === 3 ?
                                                <div>
                                                    {
                                                        this.props.recordedSession  ?
                                                            <a onClick={this.handleBackToPage} className="backArrow bck fl">
                                                                <span><b>BACK</b></span>
                                                            </a>
                                                        :
                                                            <div>
                                                            <DialogBox
                                                                backFunction
                                                                confirmDelete={this.handleBackToPageConditional}
                                                                modalOpen={this.state.modalDialog}
                                                                sectionContent={this.state.responseContent}
                                                                closeClick={(active)=>{this.setState({modalDialog: active});}}
                                                                />
                                                                <a onClick={this.handleBackToPageConditional} className="backArrow bck fl">
                                                                     <span><b>BACK</b></span>
                                                                </a>
                                                             </div>
                                                    }

                                                </div>
                                                :
                                                    <div className={"row"}>
                                                    <div className={"col-md-2 col-sm-4"}>
                                                        <a onClick={this.handleBackToPage} className="backArrow bck fl">
                                                            <span><b>BACK</b></span>
                                                        </a>
                                                    </div>
                                                        {
                                                            this.props.practice ?
                                                                <div className={"col-md-10 col-sm-8"}>
                                                                    <h1 style={{textAlign:'right'}}>PRACTICE</h1>
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>

                                        }
                                    </div>
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const bindActionToProps = dispatch => {
    return {
        updateStudent: async (student) => await dispatch(updateStudent(student)),
    };
};

const mapStateToProps = state => ({
    appStates: state.studentReducer.appStates,
    student: state.teacherReducer.student,
    studentUser: state.studentReducer.studentUser
});

export const Buttons = connect(mapStateToProps, bindActionToProps)(withRouter(ButtonContainerComponent));
export const Buttons1 = connect(mapStateToProps, bindActionToProps)(withRouter(ButtonContainerComponent1));



// WEBPACK FOOTER //
// ./src/StudentsComponent/Common.js